import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import TileGrid from 'ol/tilegrid/TileGrid';
import {createSlowupStyle, getSlowupMinResolutionForFeature} from './slowupsStyle.js';

import GeoJSON from 'ol/format/GeoJSON';
import {Z_INDEX} from "../constants";
import {EXTENT, RESOLUTIONS} from "../sources";
import {nocookieVectorTileLoadFunction} from '../nocookieLoader.js';

// The swisstopo tile grid has a resolution of 10 meters per pixel at level 20, with a tile size of 256x256 px.
// This results in a precision of 0.625 m for vector tiles with the default 4096x4096 extent.
// (10 * 256 / 4096 = 0.625)
const maxZoom = 20;


/**
 * @param {string} apiUrl
 * @return {VectorSource}
 */
export function createSlowupVectorSource(apiUrl) {
  const source = new VectorSource({
    attributions: 'Schweizmobil',
    url: `${apiUrl}4/slowups.geojson?srid=21781`,
    format: new GeoJSON({
      dataProjection: 'EPSG:21781',
    }),
  });
  source.on('addfeature', evt => {
    const f = evt.feature;
    const minResolution = getSlowupMinResolutionForFeature(f);
    minResolution && f.set('resolution', minResolution, true);
  });
  source.set('olcs_minimumLevel', 7);
  source.set('olcs_skip', false);
  return source;
}

/**
 * @param {VectorSource} source
 * @return {VectorLayer}
 */
export function createSlowupVectorLayer(source, cacheBustingService) {
  const layer = new VectorLayer({
    source: source,
    zIndex: Z_INDEX.SLOWUP,
    extent: [420000, 30000, 900000, 350000], // swiss extent
    style: createSlowupStyle(cacheBustingService),
    layername: 'Slowup', // select slowup print layout
    name: 'Slowup',
    altitudeMode: 'clampToGround',
  });
  layer.set('kind', 'geojson_slowup_layer');
  return layer;
}


/**
 * @param {string} apiUrl
 * @return {VectorTileSource}
 */
export function createSlowupMVTSource(apiUrl) {
  const source = new VectorTileSource({
    attributions: 'Schweizmobil',
    url: `${apiUrl}4/mvt_slowups/21781/{z}/{x}/{y}.pbf`,
    projection: 'EPSG:21781',
    format: new MVT(),
    tileLoadFunction: nocookieVectorTileLoadFunction,
    tileGrid: new TileGrid({
      extent: EXTENT,
      resolutions: RESOLUTIONS.slice(0, maxZoom + 1),
    })
  });
  source.set('olcs_minimumLevel', 7);
  source.set('olcs_skip', false);
  return source;
}

/**
 * @param {VectorTileSource} source
 * @return {VectorTileLayer}
 */
export function createSlowupMVTLayer(source, cacheBustingService) {
  const layer = new VectorTileLayer({
    source: source,
    zIndex: Z_INDEX.SLOWUP,
    extent: [420000, 30000, 900000, 350000], // swiss extent
    style: createSlowupStyle(cacheBustingService),
    name: 'slowup'
  });
  layer.set('kind', 'mvt_slowup_layer');
  return layer;
}
